import React from 'react';

// Example JSONs offered to the user. Keys map to the sample data in Main.
export const EXAMPLES = [
    { key: 'simple', label: 'Simple', desc: 'A flat key/value object' },
    { key: 'array', label: 'Array', desc: 'Objects and nested arrays' },
    { key: 'complex', label: 'Complex', desc: 'A deeply nested object' },
];

const Examples = ({ onSelect }) => {
    return (
        <div className="col-lg-4 grid-margin stretch-card">
            <div className="card">
                <div className="card-body">
                    <h3 className="card-title">Example JSONs</h3>
                    <p className="card-subtitle text-muted">Load a sample to see how it renders.</p>
                    <div className="d-grid gap-2 mt-3">
                        {EXAMPLES.map(ex => (
                            <button key={ex.key}
                                    type="button"
                                    className="btn btn-outline-primary example-btn text-start"
                                    onClick={() => onSelect(ex.key)}>
                                <span className="fw-bold">{ex.label}</span>
                                <small className="d-block text-muted">{ex.desc}</small>
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Examples;
